import { AppEntities } from "../../../../config/entities";
import { CatalogListView } from "../../../Shared/CatalogListView";
import { CatalogListViewDefaultToolbarButtons } from "../../../Shared/ListViews/CatalogListViewDefaultToolbarButtons";
import { CatalogListViewToolbar } from "../../../Shared/ListViews/CatalogListViewToolbar";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";

const PosTerminalList = () => {
  const fields = [
    { title: "Name", fieldName: "name" }
    // { title: "TIN", fieldName: "tin" },
  ];

  return (
    <>
      <CatalogListView fields={fields} entity={AppEntities.PosTerminal}>
        <CatalogListViewToolbar>
          <CatalogListViewDefaultToolbarButtons />
        </CatalogListViewToolbar>
      </CatalogListView>{" "}
    </>
  );
};

export default PosTerminalList;
